import {put,takeLatest,call} from 'redux-saga/effects';
import * as productTypeService from "../../../../services/productTypeService";
import {
    UPDATE_PRODUCT_TYPE,
    UPDATE_PRODUCT_TYPE_SUCCESS,
    UPDATE_PRODUCT_TYPE_ERROR,
}
    from "../../../actions/menu/productTypes";

function* updateProductTypeSaga(action) {
    try {

        yield put({
            type: UPDATE_PRODUCT_TYPE_SUCCESS,
            payload: action.payload
        })

        yield call(productTypeService.UpdateProductType,action.payload)

    

    } catch(error) {
        yield put({
            type: UPDATE_PRODUCT_TYPE_ERROR,error: error.data
        });
    }
}


export function* updateProductTypeSagaWatcher() {
    yield takeLatest(UPDATE_PRODUCT_TYPE,updateProductTypeSaga);
}